import { Cmc } from '@/models/Cmc';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '@/models/httpError';
import { HTTP } from '@/http-common';
import cmcFields from '@/models/cmcFields';
const state = {
  rows: [],
  message: new httpError(),
  fields: cmcFields.fields,
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  setCmc(state, Cmcs) {
    // state.rows.length = 0;
    if (Cmcs[0].cmcID === 0) {
      Cmcs[0].licenses.forEach((x) => {
        if (x.quantity == null || x.quantity != 0) x.quantity = 0;
      });
    }

    state.rows = Cmcs;
  },
  addRow(state) {
    if (state.rows.length > 0) state.rows.push(new Cmc());
    else {
      state.rows = [new Cmc()];
    }
  },
  deleteRow(state) {
    // To enable multi-row form handling
    // we make it possible to add new rows.
    state.rows.pop();
  },
  setProgress(state, message) {
    state.message = message;
  },
  removeRow(state, CmcID) {
    state.rows.filter(function (el) {
      return el.CmcID !== CmcID;
    });
  },
  updateField,
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit('setCmc', [new Cmc({ licenses: state.fields, product: 'insight' })]);
  },
  async getCmc({ commit, dispatch, rootState }) {
    try {
      var order = await HTTP.get(
        'order/GetCmc/' + rootState.orders.rows[0].orderID
      );
      if (order.status == 200) {
        commit('setCmc', order.data);
      } else dispatch('reset');
      dispatch(
        'setMessage',
        new httpError({ message: 'Retreived OK', httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error getting Cmc:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async saveCmc({ commit, dispatch, rootState }, rows) {
    try {
      var order = await HTTP.post(
        'order/AddCmc/' + rootState.orders.rows[0].orderID,
        rows
      );
      commit('setCmc', order.data);
      dispatch(
        'setMessage',
        new httpError({ message: 'saved OK', httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({ message: 'unable to save:' + err, httpStatus: 500 })
      );
      return Promise.reject(err);
    }
  },
  async removeRows({ state, commit, rootState }, newVal) {
    var oldVal = 0 || state.rows.length;
    var rows = [];
    for (var i = oldVal; i > newVal; i--) {
      rows.push(state.rows[i - 1].cmcID);
      commit('deleteRow');
    }
    try {
      var Cmcs = await HTTP.delete(
        'order/DeleteCmcFromOrder/' + rootState.orders.rows[0].orderID,
        { data: rows }
      );
      return Promise.resolve(Cmcs);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  removeRow({ state, commit, dispatch, rootState }, index) {
    return new Promise((resolve, reject) => {
      HTTP.delete(
        'order/DeleteCmcFromOrder/' + rootState.orders.rows[0].orderID,
        { data: [index] }
      )
        .then(() => {
          commit('deleteRow');
          resolve();
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'unable to save:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
